import {useNavigate, useSearchParams} from 'react-router-dom';
import {SoopButtonCommon} from '@soop-ui/soop-ui';
import {useSurveyForm} from '@/hooks/help';
import {ROUTE} from '@/constants/main/route';
import SurveyBody from '../SurveyLayer/SurveyBody';
import styles from './MyInquirySurvey.module.scss';
import {useDeviceDetection} from '@/hooks/useDeviceDetection';

const MyInquirySurvey = () => {
  const deviceType = useDeviceDetection('userAgent');
  const isMobile = deviceType === 'mobile';
  const [searchParams] = useSearchParams();
  const inquiryId = searchParams.get('inquiryId');
  const {surveyForm, setSurveyForm, isSubmitActive, evaluateInquiry} =
    useSurveyForm({
      inquiryId: inquiryId || '',
      onSuccess: () => {
        navigate(ROUTE.INDEX);
      },
    });
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>만족도 평가</h3>
      <div className={styles.section}>
        <SurveyBody
          variant='page'
          isMobile={isMobile}
          surveyForm={surveyForm}
          setSurveyForm={setSurveyForm}
        />
        <SoopButtonCommon
          disabled={!isSubmitActive}
          variant='defaultPrimary'
          size={44}
          className={styles.submit}
          onClick={evaluateInquiry}>
          평가하기
        </SoopButtonCommon>
      </div>
    </div>
  );
};

export default MyInquirySurvey;
